/* models/glyphs/area */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var glyph_1 = require(127) /* ./glyph */;
    var utils_1 = require(149) /* ./utils */;
    var AreaView = /** @class */ (function (_super) {
        tslib_1.__extends(AreaView, _super);
        function AreaView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AreaView.prototype.draw_legend_for_index = function (ctx, bbox, index) {
            utils_1.generic_area_legend(this.visuals, ctx, bbox, index);
        };
        AreaView.__name__ = "AreaView";
        return AreaView;
    }(glyph_1.GlyphView));
    exports.AreaView = AreaView;
    var Area = /** @class */ (function (_super) {
        tslib_1.__extends(Area, _super);
        function Area(attrs) {
            return _super.call(this, attrs) || this;
        }
        Area.initClass = function () {
            this.mixins(['fill', 'hatch']);
        };
        Area.__name__ = "Area";
        return Area;
    }(glyph_1.Glyph));
    exports.Area = Area;
    Area.initClass();
}
